<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="copy"></a><a id="page_vi"></a>Copyright © 2008 Fordham University Press</p>
<p class="copyright">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher.</p>
<p class="copyright"><em>The Animal That Therefore I Am</em> was originally published in French as <em>L’animal que donc je suis</em> © 2006 Éditions Galilée.</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright1">Derrida, Jacques.</p>
<p class="copyright2">[Animal que donc je suis. English]</p>
<p class="copyright2">The animal that therefore I am / Jacques Derrida ; edited by Marie-Louise Mallet ; translated by David Wills.</p>
<p class="copyright2">     p. cm.</p>
<p class="copyright2">Includes bibliographical references (p. ).</p>
<p class="copyright2">ISBN-13: 978-0-8232-2790-7 (cloth : alk. paper)</p>
<p class="copyright2">ISBN-13: 978-0-8232-2791-4 (pbk. : alk. paper)</p>
<p class="copyright2">1. Animals (Philosophy) I. Mallet, Marie-Louise. II. Title.<br/>B2430.D483A5513     2008<br/>194—dc22                                                                          2008007491</p>
<p class="copyright">This work has been published with the assistance of the National Center for the Book—French Ministry of Culture.</p>
<p class="copyright">Ouvrage publié avec le soutien du Centre national du livre—ministère français chargé de la culture.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?6afa0246